export default {
    export: 'Export',
    'export-as-excel': 'Export to excel',
    'print-accounts-tree': 'Print accounts tree',
    'account-num-or-name': 'Account ID or name',
    add: 'Add',
    'please-select-account' : 'Please choose an account',
    'number-of-main-accounts': 'Main accounts number:',
    'number-of-sub-accounts': 'Sub-accounts number:',
}